import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { filter } from 'rxjs';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent  implements OnInit {

  baseUrl: any;
  isFibre: boolean = false;
  isApp: boolean = false;
  isIos: boolean = false;

  constructor(private router: Router, private platform: Platform) {
    // detect if the platform is ios
    if (this.platform.is('ios')) {
      this.isIos = true;
    }
  }

  ngOnInit() {
    this.setBaseUrl(this.router.url);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const url = this.router.url;
      this.setBaseUrl(url);
    });
  }

  setBaseUrl(url: string){
    this.baseUrl = url.split('/').slice(0, 3).join('/');
    this.isFibre = url.includes('fibre');
    this.isApp = url.includes('app');
  }

  goTo(tab: string){
    const newRoute = this.baseUrl + tab;
    this.router.navigate([newRoute]);
  }

}
